import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentStep: 1,
  formData: {
    // Setup step data
    name: '',
    rewardId: '',
    rewardType: '',
    points: '',
    allCustomers: false,
    excludeSegments: false,
    selectedSegments: [],
    // Bonus products specific fields
    selectedProducts: [],
    fetchedProducts: [],
    orderQuantity: '',
    bonusProductLimit: '',
    // Attributes step fields
    startDate: null,
    endDate: null,
    startDateDisplay: '',
    endDateDisplay: '',
    displayOutOfStock: false,
    inStock: false,
    unlimitedInventory: false,
    // Cash/Physical/Product/visacard specific fields
    quota: '',
    leftoverInventory: '',
    limitPerStore: '',
    maxQuantityPerOrder: '',
    //pepvoucherorproducts fields
    selectedPepVouchersProducts: [],
    // Visa card type both fields (physical and digital)
    quotaDigitalCard: '',
    leftoverInventoryDigitalCard: '',
    limitPerStoreDigitalCard: '',
    quotaPhysicalCard: '',
    leftoverInventoryPhysicalCard: '',
    limitPerStorePhysicalCard: '',
    // PEP vouchers or products
    selectedPepVouchersOrProducts: [],
    // Display step fields (per product only)
    display: {
      // productId -> { useDefaultImage:boolean, images:[{position,url,file}], defaultImages:[url], alertDisplayCount:number, shownOnHomepage:boolean, rewardText: { lang: {title, description} } }
      productDisplay: {},
    },
    // Visa cards related properties
    redeemPoints: '',
    rewardCardType: '',
    rewardCashAmount: '',
    // Cash/Discount/PepVoucher Discount related properties
    value: '',
  },
  validation: {
    nameValid: undefined,
    rewardTypeValid: undefined,
    pointsValid: undefined,
    selectedProductsValid: undefined,
    orderQuantityValid: undefined,
    bonusProductLimitValid: undefined,
    // Visa cards
    redeemPointsValid: undefined,
    rewardCardTypeValid: undefined,
    rewardCashAmountValid: undefined,
    // Cash/Discount/PepVoucher Discount
    valueValid: undefined,
    // Attributes step validation
    startDateValid: undefined,
    endDateValid: undefined,
    // Cash/Physical/Product/VisaCard(Physical or Digital Card Type) validation
    quotaValid: undefined,
    leftoverInventoryValid: undefined,
    limitPerStoreValid: undefined,
    maxQuantityPerOrderValid: undefined,
    // Visa card type both fields (physical and digital)
    quotaDigitalCardValid: undefined,
    leftoverInventoryDigitalCardValid: undefined,
    limitPerStoreDigitalCardValid: undefined,
    quotaPhysicalCardValid: undefined,
    leftoverInventoryPhysicalCardValid: undefined,
    limitPerStorePhysicalCardValid: undefined,
  },
  isLoading: false,
  error: null,
}

const rewardsSlice = createSlice({
  name: 'rewards',
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload
    },
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload }
    },
    setValidation: (state, action) => {
      state.validation = { ...state.validation, ...action.payload }
    },
    resetRewardsData: (state, action) => {
      const defaultData = action.payload || {
        currentStep: 1,
        formData: {
          name: '',
          rewardId: '',
          rewardType: '',
          points: '',
          allCustomers: false,
          excludeSegments: false,
          selectedSegments: [],
          selectedProducts: [],
          fetchedProducts: [],
          orderQuantity: '',
          bonusProductLimit: '',
          display: {
            productDisplay: {},
          },
          redeemPoints: '',
          rewardCardType: '',
          rewardCashAmount: '',
          // Cash/Discount/PepVoucher Discount related properties
          value: '',
          // Attributes step fields
          startDate: null,
          endDate: null,
          startDateDisplay: '',
          endDateDisplay: '',
          displayOutOfStock: false,
          inStock: false,
          unlimitedInventory: false,
          // Cash/Physical/Product specific fields
          quota: '',
          leftoverInventory: '',
          limitPerStore: '',
          maxQuantityPerOrder: '',
          // PEP vouchers or products
          selectedPepVouchersProducts: [],
          selectedPepVouchersOrProducts: [],
          // Visa card type both fields (physical and digital)
          quotaDigitalCard: '',
          leftoverInventoryDigitalCard: '',
          limitPerStoreDigitalCard: '',
          quotaPhysicalCard: '',
          leftoverInventoryPhysicalCard: '',
          limitPerStorePhysicalCard: '',
        },

        validation: {
          nameValid: undefined,
          rewardTypeValid: undefined,
          pointsValid: undefined,
          selectedProductsValid: undefined,
          orderQuantityValid: undefined,
          bonusProductLimitValid: undefined,
          redeemPointsValid: undefined,
          rewardCardTypeValid: undefined,
          rewardCashAmountValid: undefined,
          // Cash/Discount/PepVoucher Discount
          valueValid: undefined,
          // Attributes step validation
          startDateValid: undefined,
          endDateValid: undefined,
          // Cash/Physical/Product/VisaCard(Physical or Digital Card Type) validation
          quotaValid: undefined,
          leftoverInventoryValid: undefined,
          limitPerStoreValid: undefined,
          maxQuantityPerOrderValid: undefined,
          // Visa card type both fields (physical and digital)
          quotaDigitalCardValid: undefined,
          leftoverInventoryDigitalCardValid: undefined,
          limitPerStoreDigitalCardValid: undefined,
          quotaPhysicalCardValid: undefined,
          leftoverInventoryPhysicalCardValid: undefined,
          limitPerStorePhysicalCardValid: undefined,
          // PEP vouchers or products validation - Add this field
          selectedPepVouchersProductsValid: undefined,
        },
      }
      return { ...state, ...defaultData }
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
  },
})

export const {
  setCurrentStep,
  setFormData,
  setValidation,
  resetRewardsData,
  setLoading,
  setError,
} = rewardsSlice.actions

export default rewardsSlice.reducer
